export default "__VITE_ASSET__xywKVuAs__"